const ET_DOMAIN = "empaquetotal.com";

export const getInvoiceGroupByEmail = (email = "") => {
  const normalizedEmail = String(email).trim().toLowerCase();
  const domain = normalizedEmail.includes("@") ? normalizedEmail.split("@")[1] : "";
  return domain === ET_DOMAIN ? "ET" : "LL";
};

export const getInvoiceGroupByProjectId = (projectId = "") => {
  const normalizedProjectId = String(projectId).trim().toUpperCase();
  if (normalizedProjectId.startsWith("ET")) {
    return "ET";
  }
  return "LL";
};
